module.exports = __webpack_public_path__ + "img/flag-icon-usa.d2fc9df8.svg";